import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Keep a single, intentional log path for render failures.
    console.error("Unhandled UI error:", error, info?.componentStack);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 16,
          minHeight: "100vh",
          padding: 24,
          textAlign: "center",
          color: "#fff",
          background: "#111",
        }}
      >
        <h2 style={{ margin: 0 }}>Something went wrong</h2>
        <p style={{ maxWidth: 420, opacity: 0.8 }}>
          The page hit an unexpected error. Reloading usually fixes it.
        </p>
        <button
          onClick={this.handleReload}
          style={{
            padding: "10px 20px",
            borderRadius: 8,
            border: "none",
            background: "#4361ee",
            color: "#fff",
            cursor: "pointer",
          }}
        >
          Reload
        </button>
      </div>
    );
  }
}
